import moment from "moment"

/**
 * Converts a UTC timestamp to the browser's local timezone
 * @param utcTimestamp - Timestamp in milliseconds (UTC)
 * @returns The same moment in time, displayed in local timezone
 */
export const convertToLocalTimezone = (utcTimestamp: number) => {
  // Create a moment in UTC and convert to local
  return moment.utc(utcTimestamp).local().valueOf()
}

/**
 * Converts a local timestamp to UTC
 * @param localTimestamp - Timestamp in milliseconds (local timezone)
 * @returns The same moment in time, in UTC
 */
export const convertToGMTTimezone = (localTimestamp: number) => {
  // Create a moment in local timezone and convert to UTC
  return moment(localTimestamp).utc().valueOf()
}
